import { computeBubblesPositionsAndContainerSize } from "./computeBubblesPositionsAndContainerSize";
import { Bubble } from "./Bubble";

export function BubbleChart({ bubbles, bubbleKey, bubbleColors, icons, spacing }) {
  const [computedBubbles, [containerWidth, containerHeight]] =
    computeBubblesPositionsAndContainerSize(bubbles, spacing);

  return (
    <div
      style={{
        width: containerWidth,
        height: containerHeight,
        position: "relative",
      }}
    >
      {computedBubbles.map((bubble, index) => {
        return (
          <Bubble
            key={index}
            bubble={bubble}
            bubbleKey={bubbleKey}
            bubbleColors={bubbleColors}
            icons={icons}
          />
        );
      })}
    </div>
  );
}
